export default __webpack_public_path__ + "static/media/imp_cam_icon.37c13e80.svg";